import { usePressTitleRegexInformation } from "@api/pressTitleRegex/pressTitleRegex";

export const useRemoveKeywordOfPressTitle = (title: string) => {
  const { data: pressTitleRegexInformation } = usePressTitleRegexInformation();

  let cleanedTitle = title;

  if (pressTitleRegexInformation) {
    cleanedTitle = pressTitleRegexInformation.reduce((acc, { regex }) => {
      return acc.replace(regex, "");
    }, title);
  }

  return {
    cleanedTitle,
  };
};
